import { Outlet, NavLink } from 'react-router';
import { useAuth } from '../contexts/auth/useAuth';
import { roles } from '../types/Users';
import { useTrads } from '../contexts/trads/useTrads';

function Layout() {
  const { logout, user, hasRole,isAuthenticated } = useAuth();
  const {translate}=useTrads();
  return (
    <>
    <div className="col-12 master layout">
      <header></header>
      {/* A "layout route" is a good place to put markup you want to
          share across all the pages on your site, like navigation. */}
      {isAuthenticated?
      <nav className='navbar navbar-expand-lg bg-body-tertiary'>
        <div className="container-fluid">
          <a className="navbar-brand" href="/"><img src="/assets/logo-tiny.png" width="50" height="50" alt="push asso" /></a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#mainNavbar" aria-controls="mainNavbar" aria-expanded="false" aria-label={translate('layout_toggle')}>
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="mainNavbar">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              {hasRole(roles.Beneficiaires) ?
              <>
              <li className="nav-item">
                <NavLink to="/" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')} end>{translate('layout_home')}</NavLink>
              </li>
             
              <li className="nav-item"><NavLink to="/demande" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')} >{translate('layout_demandes')}</NavLink></li>
              </>
              :null}
              {hasRole(roles.Operators) ?
                <>
                  <li className="nav-item"><NavLink to="/user" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link ')}>{translate('layout_users')}</NavLink></li>
                </>
                : null}
              
              <li className="nav-item"><NavLink to="/perso" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link ')}>{translate('layout_fondperso')}</NavLink></li>


              {hasRole(roles.Operators) ?
                <>
                  <li className="nav-item"><NavLink to="/fond" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link ')}>{translate('layout_fonds')}</NavLink></li>
                </>
                : null}

              {hasRole(roles.Administrators) ?
                <>
                  <li className="nav-item"><NavLink to="/type_frais" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link ')}>{translate('layout_typefrais')}</NavLink></li>
                  <li className="nav-item"><NavLink to="/transactions" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link ')}>{translate('layout_transactions')}</NavLink></li>
                  <li className="nav-item"><NavLink to="/metas" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link ')}>{translate('layout_metas')}</NavLink></li>
                  <li className="nav-item"><NavLink to="/blocs" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link ')}>{translate('layout_blocs')}</NavLink></li>
                  <li className="nav-item"><NavLink to="/traductions" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link ')}>{translate('layout_traductions')}</NavLink></li>
                  <li className="nav-item"><NavLink to="/reglements" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link ')}>{translate('layout_reglements')}</NavLink></li>
                  <li className="nav-item"><NavLink to="/dons" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link ')}>{translate('layout_dons')}</NavLink></li>
                  <li className="nav-item"><NavLink to="/logs" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link ')}>{translate('layout_logs')}</NavLink></li>
                  <li className="nav-item"><NavLink to="/pages" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link ')}>{translate('layout_pages')}</NavLink></li>
                </>
                : null}
              {/*
              <li className="nav-item"><NavLink to="/profil" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>{translate('layout_profil')}</NavLink></li>
              */}
            </ul>
          </div>
          <div className="d-flex gap-2 align-items-center border-start ps-2">
            <NavLink to="/profil" className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}>
            <i className={`text-handifin h5 bi ${user?.rangacces=="UA"?"bi-person-fill-gear":
                                user?.rangacces=="UM"?"bi-person-gear":
                                user?.rangacces=="UO"?"bi-person-check":
                                "bi-person-circle"}`}></i>
            
            {user?.identifiant}
            </NavLink>

            <a onClick={logout}><i className="bi bi-box-arrow-right"><span className="visually-hidden">{translate('layout_logout')}</span></i></a>
          </div>
        </div>

      </nav>
      :null}

      {/* An <Outlet> renders whatever child route is currently active,
          so you can think about this <Outlet> as a placeholder for
          the child routes we defined above. */}
      <div id="page-content">
        <Outlet />
      </div>
      
    </div>
    <footer>
      <div className="soutien">
        <div className="wtf">
        <img src="/assets/wtf-fund-crop.jpg" width="100" height="108" alt="Fonds ING - What The Finance - 2025" />
        </div>
        <p><span>Projet réalisé avec le soutien de ING Fund What The Finance </span></p>
        <div className="autonomia">
        <img width="173" height="160"  src="/assets/logo_autonomia.svg" alt="autonomia asbl" />
        </div>
      </div>
      {translate('global_footer')}
    </footer>
    </>
  );
}

export default Layout;